export default __webpack_public_path__ + "static/media/assail.ddc1ef62.png";